import React from 'react';

import { margin, classnames } from '@lumapps/classnames';
import { Divider } from '@lumapps/lumx/react';

interface DrawerDividerProps {
    className?: string;
}

export const DrawerDivider: React.FC<DrawerDividerProps> = ({ className }) => {
    return <Divider className={classnames(className, margin('vertical', 'huge'))} />;
};
